import { render, staticRenderFns } from "./SettingHeader.vue?vue&type=template&id=0b6c3eb8&scoped=true&"
import script from "./SettingHeader.vue?vue&type=script&lang=js&"
export * from "./SettingHeader.vue?vue&type=script&lang=js&"
import style0 from "./SettingHeader.vue?vue&type=style&index=0&id=0b6c3eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c3eb8",
  null
  
)

export default component.exports